import React from 'react'

import {
    Show, TabbedShowLayout, Tab, ReferenceField, ArrayField, Datagrid,
    TextField, ImageField, FileField, NumberField, FunctionField, SelectField
} from 'react-admin'
import { typeOwner } from '../../constant/TypeOwner'

export const RoomShow = (props) => {
    return (
        <Show {...props}>
            <TabbedShowLayout>
                <Tab label="general">
                    <ReferenceField linkType={false} label="Project name" source="project" reference="project">
                        <TextField source="name" />
                    </ReferenceField>
                    <TextField label="Room name" source="name" />
                    <TextField label="Room type" source="type" />
                    <NumberField label="Room area" source="area" />
                </Tab>
                <Tab label='owner'>
                    <ArrayField source="users">
                        <Datagrid>
                            <ReferenceField label="User" source="id" reference="user" linkType={false}>
                                <FunctionField label="Email" render={record => `${record.email} ${record.provider || ''}`} />
                            </ReferenceField>
                            <SelectField source="type" choices={typeOwner} />
                        </Datagrid>
                    </ArrayField>

                </Tab>
                <Tab label='images'>
                    <ImageField source="images" src="url" title="name" />
                </Tab>
                <Tab label='payment'>
                    <NumberField label="จำนวนงวด" source="payment.period" />
                    <NumberField label="งวดละ" source="payment.monthly" />
                    <TextField label="เริ่มจ่ายวันที่" source="payment.start" />
                    <NumberField label="จ่ายทุกวันที่" source="payment.every_date" />
                </Tab>
                <Tab label="warranty">
                    <ArrayField source="warranty">
                        <Datagrid>
                            <TextField source="name" />
                            <TextField label="Shop bought" source="shop" />
                            <TextField label="Expire date" source="expire" />
                            <ImageField source="images" src="url" title="name" label="Images" />
                        </Datagrid>
                    </ArrayField>
                </Tab>
            </TabbedShowLayout>
        </Show>
    )
};


// WEBPACK FOOTER //
// ./src/components/room/RoomShow.js